<template>
  <iframe :src="frameUrl"
          width="900"
          height="1300"
          style="border:none;padding-bottom:96px;" />
</template>
<script>
import httpService from '@/helper/httpService';
export default {
  name: "LandwirtschaftPage",
  props: {
    frameUrl: {
      type: String,
      default: '/maklerportal/abschluss.aspx?P=LW'
    }
  },
  computed: {
    computedFrameUrl() {
      return httpService.adjustLegacyUrl(this.frameUrl);
    }
  }
};
</script>
